import React from 'react'
import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import { useStyles } from './styles'

const Alert = ({ title, content, textBtn1, textBtn2, funcBtn, open, onClose }) => {
    const classes = useStyles()
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Typography className={classes.content}>{content}</Typography>
                <div className={classes.btnsContainer}>
                    <Button className={classes.cancelBtn} onClick={onClose}>{textBtn1}</Button>
                    {textBtn2 !== '' && <Button color='tumblr' className={classes.acceptBtn} onClick={funcBtn}>{textBtn2}</Button>}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export { Alert }